export enum SidebarType {
  Home,
  App,
  Topic
}
